import styled from "styled-components";

// UNUSED, remove!

export const List = styled.ul`
  list-style: none;
`;

export const ListItem = styled.li`
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;
